import { Heading, Tag, Text } from '@flixbus/honeycomb-react';
import { Icon, IconProfile } from '@flixbus/honeycomb-icons-react';

import { useVoucher } from '../../context/VoucherProdiver';
import { DiscountTypeMap } from '../../types/Voucher';

import styles from './voucher-banner.module.scss';

const VoucherBanner = () => {
  const { data } = useVoucher();

  return (
    <div className={styles.container}>
      <div className={styles.voucherType}>
        <div className={styles.icon}>
          <flix-illustration name='voucher'></flix-illustration>
        </div>
        <div className={styles.voucherTypeText}>
          <Heading flushSpace size={4}>
            {DiscountTypeMap[data.discountType.type]}
          </Heading>
          <Heading flushSpace size={1}>
            {data.code}
          </Heading>
          <Text Elem='strong' small>
            Voucher ID: {data.id}
          </Text>
        </div>
      </div>
      <div className={styles.author}>
        <div className={styles.authorIcon}>
          <Icon InlineIcon={IconProfile} size={6}></Icon>
        </div>
        <div className={styles.authorText}>
          <Text extraClasses={styles.createdBy} small>
            Created by
          </Text>
          <Tag display='subtle' small>
            {data.createdBy || 'John Doe'}
          </Tag>
        </div>
      </div>
    </div>
  );
};

export default VoucherBanner;
